import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Surveys_ds_submitted_survey_inputs_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { surveyId: number }): 
  Promise<{ result: { id?: number, index?: number, inputBoolean?: boolean, inputDate?: string, inputNumeric?: number, inputText?: string, isCompleted?: boolean, Element?: { elementTypeId?: number, text?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.surveyId)) {
      missingRequiredInParams.push('\'surveyId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Surveys/datasources/ds_submitted_survey_inputs_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { surveyId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { id?: number, index?: number, inputBoolean?: boolean, inputDate?: string, inputNumeric?: number, inputText?: string, isCompleted?: boolean, Element?: { elementTypeId?: number, text?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.surveyId)) {
      missingRequiredInParams.push('\'surveyId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Surveys/datasources/ds_submitted_survey_inputs_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { surveyId: number, $keys: number[] }): 
  Promise<{ result: { id?: number, index?: number, inputBoolean?: boolean, inputDate?: string, inputNumeric?: number, inputText?: string, isCompleted?: boolean, Element?: { elementTypeId?: number, text?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.surveyId)) {
      missingRequiredInParams.push('\'surveyId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Surveys/datasources/ds_submitted_survey_inputs_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      surveyId: number    }) {
        if(isNil(inParams.surveyId)) {
          return true; 
        }
      return false;
    }
}
